var map = {
	"./cs.svg": "af4e",
	"./de.svg": "29f1",
	"./en.svg": "317c",
	"./es.svg": "9b07",
	"./fr.svg": "0715",
	"./it.svg": "c4bc",
	"./ja.svg": "4652",
	"./lt.svg": "979c",
	"./ms.svg": "22fb",
	"./pl.svg": "acb1",
	"./qr_code_blur.svg": "e971",
	"./ru.svg": "ce2d",
	"./sl.svg": "352e",
	"./sr.svg": "2be3",
	"./uk.svg": "451a",
	"./unknown.svg": "3b3d",
	"./zh.svg": "41c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";